import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  // Defaults are empty so the template can fall back to a localized string;
  // a caller that passes an (already-translated) value still wins.
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() showRetry: boolean = false;
  @Input() showBackLink: boolean = false;
  @Input() backLinkText: string = '';
  @Input() backLinkRoute: string = '/';
  
  @Output() retry = new EventEmitter<void>();
  
  onRetry(): void {
    this.retry.emit();
  }
}
